import { withTranslation } from "react-i18next"
import withRouter from "../../../../components/Common/withRouter"
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createSelector } from "reselect";
import React, { useCallback, useEffect, useState } from "react";

import {
    loadDeductionCategory as onLoadDeductionCategory,
    updateDeductionCategory as onUpdateDeductionCategory
} from "../../../../slice/payroll/thunks";
import { toast } from "react-toastify";
import GlobalLoader from "../../../../components/Common/GlobalLoader";
import BreadCrumb from "../../../../components/Common/BreadCrumb";
import { Card, CardBody, CardHeader, Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useFormik } from "formik"
import * as Yup from "yup";

const EditDeductionCategory = (props) => {

    const dispatch = useDispatch();
    const history = useNavigate();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const selectLayoutState = (state) => state.Payroll;
    const PayrollProperties = createSelector(
        selectLayoutState,
        (payroll) => ({
            deductionCategory: payroll?.deductionCategory ?? null,
            error: payroll?.error ?? null
        })
    );

    const { deductionCategory, error } = useSelector(PayrollProperties);

    const getDeductionCategory = useCallback(() => {
        dispatch(onLoadDeductionCategory(id))
            .unwrap()
            .then(() => {
                setIsLoading(false);
            })
            .catch((error) => {
                toast.error(error?.message);
            }
        );
    }, [dispatch, id]);

    useEffect(() => {
        if (id) {
            getDeductionCategory();
        } else {
            toast.error("Invalid Deduction Category ID");
            history("/payroll/deduction-categories");
        }
    }, [dispatch, getDeductionCategory, id, history]);


    const onClickOnSave = useCallback((values) => {
            setIsSubmitting(true);
            dispatch(onUpdateDeductionCategory({id: id, data: values}))
                .unwrap()
                .then((response) => {
                    toast.success(response.message || "Deduction category successfully updated");
                    history("/payroll/deduction-categories");
                })
                .catch((error) => {
                    setIsSubmitting(false);
                    toast.error(error.message);
                });

    }, [dispatch, setIsSubmitting, history, id])

    const addDeductionFormDef = useFormik({
            enableReinitialize: true,
            initialValues: {
                name: deductionCategory?.name || "",
                position: deductionCategory?.position || 1,
            },
            onSubmit: (values) => {
                onClickOnSave(values);
            },
            validationSchema: Yup.object({
                name: Yup.string().trim().required("Name of the category is required"),
                position: Yup.string()
                            .matches(/^[1-9]([0-9]?)+$/, "Rank must be a positive integer")
                            .required("Rank is required"),
            }),
            validateOnChange: true,
            validateOnBlur: true,
            validateOnMount: false,
            initialStatus: {
                isLoading: false,
                error: null,
                success: null
            }
    });

    return (
            <React.Fragment>
                {isLoading ?
                    <GlobalLoader />
                    :
                            <div className="deduction-categories px-3">
            <div className="patients-list py-4 px-2  ">
                <div className="container-fluid">
                    <div className="row list-patients d-flex  justify-content-between">
                        <Link to="/payroll/deduction-categories" className="col-lg-5">
                            <BreadCrumb title={props.t("deduction_categories")} pageTitle={props.t("edit_deduction_category")} />
                        </Link>
                    </div>

                    <Card className="card table-card">
                        <CardHeader className="bg-light p-3">
                            <h5>{props.t("edit_deduction_category")}</h5>
                        </CardHeader>
                        <CardBody>
                            <div className="container">
                                <Form
                                    className="tablelist-form"
                                    autoComplete="off"
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        addDeductionFormDef.handleSubmit();
                                        return false;
                                    }}
                                    >
                                        <Row>
                                            <Col md={12} sm={12}>
                                                <div className="mb-3">
                                                    <Label className="form-label">
                                                        Name of category
                                                        <span className="text-danger">*</span>
                                                    </Label>
                                                    <Input
                                                        name="name"
                                                        type="text"
                                                        value={addDeductionFormDef.values.name}
                                                        onChange={addDeductionFormDef.handleChange}
                                                        onBlur={addDeductionFormDef.handleBlur}
                                                        invalid={addDeductionFormDef.touched.name && !!addDeductionFormDef.errors.name}
                                                    />
                                                    <FormFeedback>
                                                        {addDeductionFormDef.errors.name}
                                                    </FormFeedback>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12} sm={12}>
                                                <div className="mb-3">
                                                    <Label className="form-label">
                                                        Rank
                                                        <span className="text-danger">*</span>
                                                    </Label>
                                                    <Input
                                                        name="position"
                                                        type="text"
                                                        value={addDeductionFormDef.values.position}
                                                        onChange={addDeductionFormDef.handleChange}
                                                        onBlur={addDeductionFormDef.handleBlur}
                                                        invalid={addDeductionFormDef.touched.position && !!addDeductionFormDef.errors.position}
                                                    />
                                                    <FormFeedback>
                                                        {addDeductionFormDef.errors.position}
                                                    </FormFeedback>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="align-items-center p-3">
                                            <Col md={6} sm={12}>
                                                <div className="col-sm justify-content-start">
                                                    <span className="text-danger">
                                                        * : Required fields
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col md={6} sm={12}>
                                                <div className="col-sm-auto">
                                                    <div className="hstack gap-2 justify-content-end">
                                                        <Link to="/payroll/deduction-categories" className="btn btn-std mx-2">
                                                            <i className="fas fa-times mx-1"></i>
                                                            {props.t("cancel")}
                                                        </Link>
                                                        <button
                                                            type="submit"
                                                            className="btn btn-std mx-2"
                                                            disabled={isSubmitting || !addDeductionFormDef.isValid}
                                                        >
                                                            <i className="fas fa-save mx-1"></i>
                                                            {props.t("update")}
                                                        </button>
                                                    </div>
                                                </div>
                                            </Col>

                                        </Row>
                                </Form>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
                }
            </React.Fragment>
    );
}

export default withRouter(withTranslation()(EditDeductionCategory))